module.exports = __webpack_public_path__ + "static/Speeches-9ba5958fa3892bb62988615c8b38cc7e.jpg";